/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
/**
 * A html ui for state display. Can be used to display binary states.
 */
export class ShowUiState {
    constructor(name) {
        this._hideHandle = 0;
        this.name = name;
        const rowEl = document.createElement('div');
        rowEl.classList.add('ShowUiState--hidden');
        const el = document.createElement('div');
        el.classList.add('ShowUiState--state');
        el.innerHTML = `${name}`;
        const extraStyles = ShowUiState.colorStyles.shift();
        ShowUiState.colorStyles.push(extraStyles);
        el.setAttribute('style', extraStyles);
        rowEl.appendChild(el);
        ShowUiState.getContainer().appendChild(rowEl);
        this.el = rowEl;
    }
    static getContainer() {
        let container = document.getElementById('ShowUiState');
        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', 'ShowUiState');
            container.classList.add('ShowUiState--container');
            document.body.appendChild(container);
            const styles = document.createElement('style');
            styles.innerHTML = `
        .ShowUiState--container {
          position: fixed;
          top: 0;
          right: 0;
          text-align: right;
          pointer-events: none;
        }
        .ShowUiState--state {
          font-size: 24px;
          font-family: sans-serif;
          font-weight: bold;
          padding: 4px 8px;
          display: inline-block;
        }
        .ShowUiState--hidden {
          display: none;
        }
      `;
            document.head.appendChild(styles);
        }
        return container;
    }
    hide() {
        this.el.classList.add('ShowUiState--hidden');
        this._clearTimeout();
    }
    show(hideAfterMs = 0) {
        this.el.classList.remove('ShowUiState--hidden');
        this._clearTimeout();
        if (hideAfterMs > 0) {
            this._hideHandle = window.setTimeout(() => this.hide(), hideAfterMs);
        }
    }
    _clearTimeout() {
        if (this._hideHandle) {
            window.clearTimeout(this._hideHandle);
            this._hideHandle = 0;
        }
    }
}
ShowUiState.colorStyles = [
    'background: #ff8484; color: #fff;',
    'background: #c7f0db; color: #333;',
    'background: #d84c73; color: #fff;',
    'background: #8bbabb; color: #333;',
    'background: #5c3b6f; color: #fff;',
    'background: #6c7b95; color: #fff;',
    'background: #35234b; color: #fff;',
    'background: #464159; color: #fff;',
];
/**
 * A simple html console displayed as overlay.
 */
export class UiLog {
    static getContainer() {
        let container = document.getElementById('UiLog');
        if (!container) {
            container = document.createElement('div');
            container.setAttribute('id', 'UiLog');
            container.classList.add('UiLog--container');
            document.body.appendChild(container);
            container.onclick = () => {
                container.innerHTML = '';
            };
            const styles = document.createElement('style');
            styles.innerHTML = `
        .UiLog--container {
          position: fixed;
          right: 0;
          bottom: 0;
          width: 150px;
          height: 220px;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.25);
          padding: .25em;
        }
        .UiLog--message {
          font-size: 11px;
          font-family: monospace;
          display: none;
        }
        .UiLog--message:nth-child(1)  { color: #ffc; display: block; }
        .UiLog--message:nth-child(2)  { color: #fff; display: block; }
        .UiLog--message:nth-child(3)  { color: #fff; opacity: 0.9; display: block; }
        .UiLog--message:nth-child(4)  { color: #fff; opacity: 0.84; display: block; }
        .UiLog--message:nth-child(5)  { color: #fff; opacity: 0.78; display: block; }
        .UiLog--message:nth-child(6)  { color: #fff; opacity: 0.72; display: block; }
        .UiLog--message:nth-child(7)  { color: #fff; opacity: 0.66; display: block; }
        .UiLog--message:nth-child(8)  { color: #fff; opacity: 0.6; display: block; }
        .UiLog--message:nth-child(9)  { color: #fff; opacity: 0.54; display: block; }
        .UiLog--message:nth-child(10) { color: #fff; opacity: 0.48; display: block; }
        .UiLog--message:nth-child(11) { color: #fff; opacity: 0.42; display: block; }
        .UiLog--message:nth-child(12) { color: #fff; opacity: 0.36; display: block; }
        .UiLog--message:nth-child(13) { color: #fff; opacity: 0.3; display: block; }
        .UiLog--message:nth-child(14) { color: #fff; opacity: 0.24; display: block; }
        .UiLog--message:nth-child(15) { color: #fff; opacity: 0.18; display: block; }
        .UiLog--message:nth-child(16) { color: #fff; opacity: 0.12; display: block; }
        .UiLog--message:nth-child(17) { color: #fff; opacity: 0.06; display: block; }
        .UiLog--counter {
          font-size: 10px;
          font-family: monospace;
          font-weight: bold;
          display: inline-block;
          border-radius: 5px;
          background: #aaa;
          color: #000;
          padding-left: 2px;
          padding-right: 2px;
        }
      `;
            document.head.appendChild(styles);
        }
        return container;
    }
    static log(message) {
        if (UiLog.last && UiLog.last.message === message) {
            ++UiLog.last.counter;
            const { el, counter } = UiLog.last;
            el.innerHTML = `
        <div class="UiLog--counter">${counter}</div>
        ${message}
      `;
        }
        else {
            const el = document.createElement('div');
            el.classList.add('UiLog--message');
            el.innerHTML = `${message}`;
            const containerEl = UiLog.getContainer();
            containerEl.prepend(el);
            UiLog.last = { message, el, counter: 1 };
            const lastEl = containerEl.querySelector('.UiLog--message:nth-child(18)');
            if (lastEl) {
                containerEl.removeChild(lastEl);
            }
        }
    }
}
UiLog.last = null;
//# sourceMappingURL=DebugUI.js.map